module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/au-5b98a120aeec3f5a1aeb9c0a8c011cf8.svg";